import { render } from "./EmissionFields.vue?vue&type=template&id=770cc628&scoped=true"
import script from "./EmissionFields.vue?vue&type=script&lang=js"
export * from "./EmissionFields.vue?vue&type=script&lang=js"

import "./EmissionFields.vue?vue&type=style&index=0&id=770cc628&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770cc628"]])

export default __exports__